import { FETCH_EXTENSION_APPROVAL_DETAIL } from "../../actions/actionTypes";

const initialState = {  
    requestDetail: {},
    loading: false,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {    
        case FETCH_EXTENSION_APPROVAL_DETAIL.REQUEST:
            return {...state,loading: true}
        case FETCH_EXTENSION_APPROVAL_DETAIL.FAILURE:
            return {...state, loading: false}
        case FETCH_EXTENSION_APPROVAL_DETAIL.SUCCESS:             
            return {...state, requestDetail: action.obj.data, loading: false}    
        default:
            return state
    }
}

export default reducer;